export default "__VITE_ASSET__C20da3Ph__"